import ValidationStripeModal from './ValidationStripeModal.view';

export default ValidationStripeModal;
